export const links = {
	WHATSAPP_SUPPORT: 'https://wa.me/525588527287'
}